import React from 'react';
import './withdraw.css';
import axios from 'axios';

export function Withdraw() {
    const onWithdraw  = (e) => {
        e.preventDefault();
        const acId = e.target.acId.value;
        const amount = e.target.amount.value;
        console.log(`Id ${acId} Amount ${amount}`);
        axios('https://www.tigerbank.store/withdraw', {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ acId, amount: parseFloat(amount.replace(/,/g, '')) }), // 수정된 부분
        })
        .then(json =>{
            console.log(json)
        })
        .catch(error =>{
            console.log('데이터 요청이 실패하였습니다.',error)
        })
    }

    return (
        <div className="wthCont">
            <div className="p--section">
                <h1>현금인출</h1>
                <form onSubmit={onWithdraw}>
                    <input type='number' placeholder='계좌 번호' name='acId' />
                    <input type='number' placeholder='금액' name='amount' />
                    <input type='submit' value='인출' />
                </form>
            </div>
        </div>
    );
}

export default Withdraw;
